function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return undefined;
}

function updateWatchlistIndicator(amount) {
  if (amount <= 0) {
    $jq3(".watchlist-indicator").remove();
    return;
  }

  if (!$jq3(".watchlist-indicator").length)
    $jq3(".main").append(
      '<div class="watchlist-indicator"><a href="/merkliste.html" class="watchlist-indicator__text">Merkliste (' +
        amount +
        ")</a></div>"
    );
  else $jq3(".watchlist-indicator__text").html("Merkliste (" + amount + ")");
}

export function watchlist() {
  var serializedObjects = getCookie("fav_objects");
  var favedObjects = [];
  if (serializedObjects !== undefined)
    favedObjects = JSON.parse(serializedObjects);

  updateWatchlistIndicator(favedObjects.length);

  $jq3(".fav-button").each(function() {
    var objectId = $jq3(this).data("objectid");

    if (objectId !== undefined && favedObjects.includes(objectId)) {
      $jq3(this).addClass("fav-button--is-faved");
    }
  });

  $jq3(".fav-button").on("click", function(e) {
    const currentObjectId = $jq3(this).data("objectid");

    if (currentObjectId === undefined) return;

    $jq3(this).toggleClass("fav-button--is-faved");

    if (
      $jq3(this).hasClass("fav-button--is-faved") &&
      !favedObjects.includes(currentObjectId)
    ) {
      favedObjects.push(currentObjectId);
    } else {
      favedObjects = favedObjects.filter(function(value, index, arr) {
        return value !== currentObjectId;
      });
    }

    updateWatchlistIndicator(favedObjects.length);

    setCookie("fav_objects", JSON.stringify(favedObjects), 30);
  });

  // var dataId = 1;

  $jq3(".watchlist__item").each(function() {
    var name =
      $jq3(this)
        .find(".watchlist__id")
        .html() +
      ": " +
      $jq3(this)
        .find(".watchlist__name")
        .html();
    var newOption = new Option(name, name, false, false);

    $jq3(".select2-box--multiple-immo")
      .append(newOption)
      .trigger("change");
  });
}
